// extracted by mini-css-extract-plugin
module.exports =  {"suffix":"hvOMKtHnJ6EgqHLc0gjO","alert":"XfrOn5jgtmwOuHArLwSg"};